import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { showInformationToast, withCookie } from '@spotahome/ui-library';

import {
  hasValidCityInfo,
  cityInformation
} from '../../components/InformationToast/informationToastUtils';

import TimerIcon from './../icons/TimerIcon';

const TOAST_EXIT_TIMEOUT = 20000;
const TOAST_ENTER_TIMEOUT = 3000;

const COOKIES_ACCEPTED_VALUE = '1';
const COOKIE_CONFIG = {
  cookieName: 'city-event-toast',
  cookieExpires: {
    days: 1
  }
};

const InformationToastWrapper = ({ city, isCookieAccepted, acceptCookie }) => {
  useEffect(() => {
    const toastProps = {
      renderIcon: () => <TimerIcon />,
      renderContent: () => trans(cityInformation('freeComission', city))
    };

    if (hasValidCityInfo(city) && !isCookieAccepted(COOKIES_ACCEPTED_VALUE)) {
      acceptCookie(COOKIES_ACCEPTED_VALUE);
      showInformationToast(toastProps, {
        autoClose: TOAST_EXIT_TIMEOUT,
        delay: TOAST_ENTER_TIMEOUT
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

InformationToastWrapper.propTypes = {
  isCookieAccepted: PropTypes.func.isRequired,
  acceptCookie: PropTypes.func.isRequired,
  city: PropTypes.string.isRequired
};

export default withCookie(COOKIE_CONFIG)(InformationToastWrapper);
